import { policyList } from "@/enums/permissions";
import { locationsApiManagementService } from "@/services/locationsApiManagement.service";
import { BooleanCheck, PageTitleComponent } from "helix-vue-components";
import Cookie from "js-cookie";
import findKey from "lodash/findKey";
import { Component as ComponentType } from "vue";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import Template from "./LocationApiManagement.template.vue";
import PmpIntegrationComponent from "./Pmp/PmpIntegrationComponent.component";
import QuickbooksComponent from "./Quickbooks/Quickbooks.component";
import StateTraceabilityComponent from "./StateTraceability/StateTraceability.component";
import StemsComponent from "./Stems/Stems.component";
import ThirdPartyComponent from "./ThirdParty/ThirdParty.component";
import WeedMapsIntegrationComponent from "./WeedMaps/WeedMapsIntegration.component";

interface ExternalServices {
  id?: number | null;
  integration_key: NameTabs;
  is_active?: number;
  name?: string;
  component: ComponentType | null;
  disabled?: boolean;
  routeName?: string;
}

enum NameTabs {
  thirdPartyKey = "THIRD_PARTY",
  quickbooksKey = "QUICKBOOKS_INTEGRATION",
  metricKey = "METRIC",
  stemsKey = "STEMS",
  weedmapskey = "WEEDMAPS_INTEGRATION",
  traceabilityKey = "STATE_TRACEABILITY_INTEGRATION",
  pmpIntegrationKey = "PMP_INTEGRATION"
}
@Component({
  mixins: [Template],
  components: {
    PageTitleComponent,
    ThirdPartyComponent,
    StemsComponent,
    QuickbooksComponent,
    WeedMapsIntegrationComponent,
    PmpIntegrationComponent
  }
})
export default class LocationApiManagementComponent extends Vue {
  public tabs: ExternalServices[] = [];
  public active: string = "0";
  public loading = false;
  @Getter("hasPermission", { namespace: "authModule" })
  public hasPermission!: BooleanCheck;
  public views: { [key: string]: ExternalServices } = {
    [NameTabs.traceabilityKey]: {
      integration_key: NameTabs.traceabilityKey,
      component: StateTraceabilityComponent,
      disabled: false,
      routeName: "state-traceability"
    },
    [NameTabs.thirdPartyKey]: {
      integration_key: NameTabs.thirdPartyKey,
      component: ThirdPartyComponent,
      disabled: false,
      routeName: "third-party"
    },
    [NameTabs.stemsKey]: {
      integration_key: NameTabs.stemsKey,
      component: StemsComponent,
      disabled: true,
      routeName: "stems-key"
    },
    [NameTabs.quickbooksKey]: {
      integration_key: NameTabs.quickbooksKey,
      component: QuickbooksComponent,
      disabled: false,
      routeName: "quickbooks"
    },
    [NameTabs.weedmapskey]: {
      integration_key: NameTabs.weedmapskey,
      component: WeedMapsIntegrationComponent,
      disabled: false,
      routeName: "weedmaps"
    },
    [NameTabs.pmpIntegrationKey]: {
      integration_key: NameTabs.pmpIntegrationKey,
      component: PmpIntegrationComponent,
      disabled: false,
      routeName: "pmp-integration"
    }
  };
  public onSetRoute() {
    const route = this.views[this.tabs![+this.active].integration_key]
      .routeName;
    if (route) {
      this.$router.push({ name: route });
    }
  }

  public tabId(i: number) {
    if (this.tabs![i].integration_key === "THIRD_PARTY") {
      return "btn_third_inte";
    } else {
      return "btn_quick_inte";
    }
  }
  public onSetLoading(value: boolean) {
    this.loading = value;
  }
  public async mounted() {
    let tabs = await locationsApiManagementService.getExternalServices();
    tabs = tabs.map((service: ExternalServices) => {
      if (service.integration_key === "QUICKBOOKS_INTEGRATION") {
        service.name = "quickbooks";
      }
      return service;
    });
    if (
      this.hasPermission(policyList.viewStateTraceabilityIntegrations) &&
      +process.env.VUE_APP_METRC
    ) {
      tabs!.unshift({
        id: null,
        integration_key: NameTabs.traceabilityKey,
        name: "state traceability",
        is_active: 1,
        component: null
      });
    }
    tabs!.push(
      {
        id: null,
        integration_key: NameTabs.weedmapskey,
        name: "weedmaps",
        is_active: 1,
        component: null
      },
      {
        id: null,
        integration_key: NameTabs.thirdPartyKey,
        name: "third party",
        is_active: 1,
        component: null
      }
    );
    if (this.hasPermission(policyList.viewPmpIntegration)) {
      tabs.splice(3, 0, {
        id: null,
        integration_key: NameTabs.pmpIntegrationKey,
        name: "prescription monitoring program",
        is_active: 1,
        component: null
      });
    }
    this.tabs = tabs!.map((item: ExternalServices) => {
      const componentTabs = this.views[item.integration_key];
      return { ...item, component: componentTabs.component };
    });
    const quickbooksIntegrations = Cookie.get("quickbooks_redirect");
    this.active = quickbooksIntegrations || "0";
    if (Number(quickbooksIntegrations)) {
      Cookie.set("quickbooks_redirect", "0", {
        domain: `${process.env.VUE_APP_COOKIE_DOMAIN}`
      });
    }
    const key = findKey(this.views, ["routeName", this.$route.name]);
    this.active =
      (key && this.tabs.findIndex(t => t.integration_key === key).toString()) ||
      "0";
  }
}
